import { Container } from "react-bootstrap";
import SectionHeading from "../ui/SectionHeading";
import { Reveal } from "../ui/Reveal";
import "../style/NameChange.css";

const NameChange = () => {
  return (
    <section className="section-pad name-change">
      <Container className="container-narrow">
        <SectionHeading
          eyebrow="A Note From Us"
          title="Idly Dosa Camp is Now Kote Cafe"
          subtitle="Same taste, same team, same love — just a new name that connects us closer to home."
        />
        <Reveal className="name-change__copy">
          <p>
            Our Vidyagiri outlet, known for years as <strong>Idly Dosa Camp</strong>,
            is now <strong>Kote Cafe</strong>. Nothing changes about the food, the
            people, or the care that goes into every plate — only the name above
            the door.
          </p>
          <p>
            &ldquo;Kote&rdquo; means <em>fort</em> — Bagalkot is still fondly
            called Kotenadu by locals, a name that carries centuries of
            strength, unity, and tradition. It felt like the right name to
            carry our story forward as we grow, including our new outlet
            opening in Navanagar.
          </p>
        </Reveal>
        <Reveal className="name-change__art">
          <img
            src="/images/why-kote-cafe.png"
            alt="Why we chose the name Kote Cafe — Kote means Fort, a symbol of strength, safety and trust, connecting us to our Bagalkote heritage. Formerly Idly Dosa Camp, Vidyagiri."
            className="name-change__img"
          />
        </Reveal>
      </Container>
    </section>
  );
};

export default NameChange;
